const $$splitPendingComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/auth/login.tsx?tsr-split=pendingComponent');
const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/auth/login.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAuthStore } from '@/Utility/auth/Auth';
import { type Auth_LoginClients_Query, type Auth_LoginClients_Query$data, LoginClientsQuery } from '@/graphql/queries/Auth.query';
import { RelayEnvironment } from '@/graphql/relay-env';
import { loadQuery } from 'react-relay';
import './login.less';
type Props = {
  isFallback?: boolean;
  data?: Auth_LoginClients_Query$data;
};
export type { Props as LoginProps };
export const Route = createFileRoute('/auth/login')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  pendingComponent: lazyRouteComponent($$splitPendingComponentImporter, 'pendingComponent'),
  beforeLoad: () => {
    const userExists = useAuthStore.getState()?.user?.userExists;
    if (userExists === true) {
      throw redirect({
        to: '/dash/catalog'
      });
    }
  },
  loader() {
    return loadQuery<Auth_LoginClients_Query>(RelayEnvironment, LoginClientsQuery, {}, {
      fetchPolicy: 'store-or-network'
    });
  }
});